const {JoinDataConfiguration} = require("./configuration/join-data-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const JoinDataStepTabs = {
    configuration: JoinDataConfiguration,
    preview: PreviewTab,
};
exports.JoinDataStepTabs = JoinDataStepTabs;
